import React from 'react';
import PropTypes from 'prop-types';

import { Translate } from 'src/translations/i18n';
import dayjs from 'dayjs';

import { withStyles } from '@material-ui/core/styles';
import {
  List,
  ListItem
} from '@material-ui/core';
import Utils from 'src/utils';

const styles = ({ palette }) => ({
  option: {
    color: palette.text.color
  },
  container: {
    marginTop: 2,
    flex: '1 0 auto',
    height: 'fit-content'
  },
  optionActive: {
    backgroundColor: palette.primary.main
  }
});

function DatePickerPeriods({
  selectedPeriod,
  periods,
  onChange,

  classes
}) {
  const [startDate, endDate] = selectedPeriod;
  const selectedPeriodObj = { startDate, endDate };

  return (
    <List dense className={classes.container}>
      { periods.map((period) => {
        const {
          startDate: start,
          endDate: end,
          translationKey: key
        } = period;

        return (
          <ListItem
            key={key}
            button
            onClick={() => onChange([start, end])}
            className={[
              classes.option,
              Utils.periods.periodEquals(selectedPeriodObj, period) ? classes.optionActive : ''
            ].join(' ')}
          >
            <Translate value={key} />
          </ListItem>
        );
      })}
    </List>
  );
}

DatePickerPeriods.propTypes = {
  selectedPeriod: PropTypes.array,
  periods: PropTypes.array,
  onChange: PropTypes.func,
  classes: PropTypes.object
};

DatePickerPeriods.defaultProps = {
  selectedPeriod: [dayjs(), dayjs()],
  periods: Object.values(Utils.periods.getPeriods()),
  onChange: ([start, end]) => console.log(start, end),
  classes: {}
};


export default withStyles(styles)(DatePickerPeriods);
